// extracted by mini-css-extract-plugin
module.exports = {"icon":"TokenIcon_icon__mIt5x","inherit":"TokenIcon_inherit__1T565"};